export const LOAD_SETTINGS = 'Dyzio/Settings/LOAD_SETTINGS';
export const LOAD_SETTINGS_SUCCESS = 'Dyzio/Settings/LOAD_SETTINGS_SUCCESS';
export const LOAD_SETTINGS_ERROR = 'Dyzio/Settings/LOAD_SETTINGS_ERROR';

export const UPDATE_SETTINGS = 'Dyzio/Settings/UPDATE_SETTINGS';
export const UPDATE_SETTINGS_SUCCESS = 'Dyzio/Settings/UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_ERROR = 'Dyzio/Settings/UPDATE_SETTINGS_ERROR';

export const NOTIFY_ACTION = 'Dyzio/Settings/NOTIFY_ACTION';



/** WEBPACK FOOTER **
 ** ./src/containers/user-settings/constants.js
 **/